import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'

export const TEXT_INPUT_COLOR = {
  red: 'red',
  black: 'black',
  purple_dark: 'purple-dark',
}

export const TEXT_INPUT_FORMATS = {
  currency: 'currency',
  currency2: 'currency-2',
  percentage: 'percentage',
  percentage2: 'percentage-2',
  month: 'month',
  year: 'year',
  templateText: 'template-text',
  phone: 'phone',
  email: 'email',
  percent2digits: 'percent2digits',
  percent2: 'percentage2',
  curr2: 'currency2',
}

export const CURRENCY_FORMATS = [
  TEXT_INPUT_FORMATS.currency,
  TEXT_INPUT_FORMATS.currency2,
  TEXT_INPUT_FORMATS.curr2,
]
export const PERCENT_FORMATS = [
  TEXT_INPUT_FORMATS.percentage,
  TEXT_INPUT_FORMATS.percentage2,
  TEXT_INPUT_FORMATS.percent2,
  TEXT_INPUT_FORMATS.percent2digits,
]

export type TextInputFormat = ValueOf<typeof TEXT_INPUT_FORMATS>

export const NUMERIC_FORMATS = {
  [TEXT_INPUT_FORMATS.currency]: true,
  [TEXT_INPUT_FORMATS.currency2]: true,
  [TEXT_INPUT_FORMATS.percentage]: true,
  [TEXT_INPUT_FORMATS.percentage2]: true,
}

export const NUMERIC_TYPES = {
  [FIELD_TYPES.number]: true,
  [FIELD_TYPES.integer]: true,
}

export const TEXT_INPUT_TYPES = {
  button: 'button',
  checkbox: 'checkbox',
  color: 'color',
  date: 'date',
  'datetime-local': 'local',
  email: 'email',
  file: 'file',
  hidden: 'hidden',
  image: 'image',
  month: 'month',
  number: 'number',
  password: 'password',
  radio: 'radio',
  range: 'range',
  reset: 'reset',
  search: 'search',
  submit: 'submit',
  tel: 'tel',
  text: 'text',
  time: 'time',
  url: 'url',
  week: 'week',
}
